import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <header class="fixed top-0 left-0 w-full z-[100]">
      <!-- Prominent Top Phone Bar -->
      <div class="bg-stone-900 text-white px-4 sm:px-8 py-2.5 flex justify-between items-center text-xs sm:text-sm border-b border-stone-800 shadow-md">
        <div class="flex items-center gap-2">
          <span class="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse"></span>
          <span class="font-sans font-medium text-stone-300 hidden sm:inline">Prefer speaking directly on the phone? Call us anytime!</span>
          <span class="font-sans font-medium text-stone-300 sm:hidden">Direct Phone Line:</span>
        </div>

        <a href="tel:6463053661" class="inline-flex items-center gap-2 bg-gold-accent hover:bg-amber-400 text-black px-4 py-1.5 rounded-full font-bold text-sm sm:text-base tracking-wide transition-all shadow-sm active:scale-95">
          <span class="material-symbols-outlined text-lg sm:text-xl">call</span>
          <span>(646) 305-3661</span>
        </a>
      </div>

      <!-- Main Navigation -->
      <nav class="bg-white dark:bg-stone-950 flex justify-between items-center w-full px-8 py-4 h-20 border-b-2 border-stone-100 dark:border-stone-900 shadow-sm">
        <div class="font-serif text-2xl font-bold text-stone-900 dark:text-stone-50 tracking-tight cursor-pointer" routerLink="/">
          Regency House Cleaning
        </div>
        
        <!-- Desktop Nav -->
        <div class="hidden md:flex gap-10 items-center">
          <a class="font-serif text-lg tracking-wide text-stone-600 dark:text-stone-400 hover:text-gold-accent transition-colors cursor-pointer active:opacity-70" 
             routerLink="/" routerLinkActive="text-gold-accent border-b-2 border-gold-accent" [routerLinkActiveOptions]="{exact: true}">Home</a>
          <a class="font-serif text-lg tracking-wide text-stone-600 dark:text-stone-400 hover:text-gold-accent transition-colors cursor-pointer active:opacity-70"
             routerLink="/about" routerLinkActive="text-gold-accent border-b-2 border-gold-accent">About</a>
          <a class="font-serif text-lg tracking-wide text-stone-600 dark:text-stone-400 hover:text-gold-accent transition-colors cursor-pointer active:opacity-70"
             routerLink="/services" routerLinkActive="text-gold-accent border-b-2 border-gold-accent">Services</a>
          <a class="font-serif text-lg tracking-wide text-stone-600 dark:text-stone-400 hover:text-gold-accent transition-colors cursor-pointer active:opacity-70"
             routerLink="/senior-independence" routerLinkActive="text-gold-accent border-b-2 border-gold-accent">Senior Care</a>
          <a class="font-serif text-lg tracking-wide text-stone-600 dark:text-stone-400 hover:text-gold-accent transition-colors cursor-pointer active:opacity-70" 
             routerLink="/team" routerLinkActive="text-gold-accent border-b-2 border-gold-accent">Our Team</a>
          <a class="font-serif text-lg tracking-wide text-stone-600 dark:text-stone-400 hover:text-gold-accent transition-colors cursor-pointer active:opacity-70" 
             routerLink="/book" routerLinkActive="text-gold-accent border-b-2 border-gold-accent">Book Now</a>
          <div class="cursor-pointer active:opacity-70 text-stone-900 dark:text-stone-50" routerLink="/portal">
            <span class="material-symbols-outlined text-3xl">account_circle</span>
          </div>
        </div>

        <!-- Mobile Profile Icon -->
        <div class="md:hidden flex items-center gap-4">
          <div class="cursor-pointer active:opacity-70 text-stone-900 dark:text-stone-50" routerLink="/portal">
            <span class="material-symbols-outlined text-3xl">account_circle</span>
          </div>
        </div>
      </nav>
    </header>
  `,
  styles: [`
    :host {
      display: block;
    }
  `],
})
export class HeaderComponent {}
